import React, { useEffect, useState } from "react";
import style from "./cargo.module.scss";
import { withRouter, Link } from "react-router-dom";
import Button from "../Button/button"
import GradientToast from "../gradientToast/Toast"
import momentJalaali from 'moment-jalaali';
import toPersianNumber from "../../helpers/actions/toPersianNumber";
import disconnectTextGenerator from "../../helpers/actions/disconnectedText"
import Pagination from "../pagination/pagination";
import TinyDropdown from "../Dropdown/tinyDropdown/tinyDropdown";
import Dropdown from "../Dropdown/RealTimeButtonDropDown/DropDown";
import LogCard from "./cargoLogCard/logCard"
import Skeleton from "./skeleton"
import Searchbar from "../productSearchbar/productSearchbar";
import toEnglishNumber from "../../helpers/actions/toEnglishNumber";
import { GetCargoConfigs, DeleteCargo, CreateCargo, EditCargo, GetCargoLogList, GetWarehouses, GetChannelList, SubmitAddChannel } from "../../actions/APIcalls"
import CalendarModal from "../modalCalendar/modalCalendar";
import CargoModal from '../cargoModal/cargoModal'
import DeleteCargoModal from '../cargoModal/DeleteCargoModal/deleteCargoModal'
import EditChannelModal from '../editChannelModal/editChannelModal'
import Toast from '../Toast/Toast'
import CargoEmptyState from '../../assets/icons/EmptyStates/cargo_noresult.svg'
import GeneralWarning from "../generalWarning/warning"


const Cargo = (props) => {
    const [openCalendarModal, setOpenCalendarModal] = useState(false)
    const [dateRangeLabel, setDateRangeLabel] = useState('')
    const [hasSkeleton, setHasSkeleton] = useState(true)
    const [editChannel, setEditChannel] = useState({
        show: false,
    })
    const [cargoModal, setCargoModal] = useState({
        show: false,
        deleteShow: false,
        channelList: []
    })
    const [logList, setLogList] = useState({
        logListPageCount: 1,
        list: [],
        warehouses: [],
        error: '',
        cargoConfigs: [],
        resultNumber: 0,
    })

    const [toast, setToast] = useState('')


    useEffect(async () => {
        await GetChannelListFunction()
        await getCargoLog()
        await GetCargoConfigsInitial()
        await GetWarehousesFunction()
    }, [])

    // if on top set navbar to fix 
    const [offset, setOffset] = useState(0);

    useEffect(() => {
        const onScroll = () => setOffset(window.pageYOffset);
        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);
    // end

    const setDateRange = (range) => {
        let urlFrom = getFromUrl("from");
        let urlTo = getFromUrl("to");
        range.start && (urlFrom = momentJalaali(range.start))
        range.end && (urlTo = momentJalaali(range.end))
        setToUrl(urlFrom, "from");
        setToUrl(urlTo, "to");
    }

    const GetCargoConfigsInitial = async () => {
        let res = await GetCargoConfigs()
        let tmp = logList
        if (res.data && res.data.list) {
            tmp.cargoConfigs = res.data.list
        }
        setLogList({ ...tmp })
    }

    const GetWarehousesFunction = async () => {
        let res = await GetWarehouses()
        let tmp = logList
        if (res && res.data) {
            tmp.warehouses = res.data.list
        }
        setLogList({ ...tmp })
    }

    const GetChannelListFunction = async () => {
        let tmp = cargoModal
        tmp.channelList = (await GetChannelList()).data.channelList
        setCargoModal({ ...tmp })
    }

    const getCargoLog = async () => {
        setHasSkeleton(true)
        let url = await getFromUrl()
        //  get cargo log list
        let res = await GetCargoLogList(url)
        if (res && res.data && res.data.success) {
            let tmp = logList
            tmp.list = res.data.list
            tmp.resultNumber = res.data.count
            tmp.logListPageCount = res.data.pageNumber
            setLogList({ ...tmp })
        }
        setHasSkeleton(false)
    }

    const deleteCargoConfigFunction = async (id) => {
        let res = await DeleteCargo(id)
        await GetCargoConfigsInitial();
        return res
    }

    const updateCargoConfigs = async (params, type) => {
        let res = ''
        if (type == 'create') {
            // create function
            res = await CreateCargo(params, openToast)
        } else {
            // edit function
            res = await EditCargo(params, openToast)
        }
        await GetCargoConfigsInitial();
        return res;
    }

    const openToast = error => {
        setToast(error)
    }

    const closeToastFunction = () => {
        setToast('')
    }

    const getFromUrl = (param) => {
        let defaultParams = {
            natureType: [],
            pageNumber: 10,
            page: 1,
            search: "",
            from: '',
            to: ''
        }
        let url = new URLSearchParams(window.location.search);

        if (param) {
            if (url.get(param)) {
                return url.get(param)
            } else {
                return defaultParams[param];
            }
        } else {
            Object.keys(defaultParams).map(function (key, index) {
                if (url.get(key)) {
                    if (key == 'natureType') {
                        let splited = url.get(key).split('*')
                        defaultParams[key] = splited
                    } else {
                        defaultParams[key] = url.get(key)
                    }
                }
            });
            return defaultParams
        }
    }

    const setToUrl = (value, param) => {
        let url = new URLSearchParams(window.location.search);
        if (Array.isArray(value)) {
            let tempString = "";
            value.map(item => {
                tempString ? tempString = `${tempString}*${item}` : tempString = item;
            })
            value.length > 0 ? url.set(param, tempString) : url.delete(param)
        } else {
            url.set(param, value);
        }
        if (param !== 'page') {
            url.set('page', 1);
        }
        props.history.push(window.location.pathname + "?" + url.toString());
        getCargoLog();
    }

    const deleteFromUrl = (param) => {
        let url = new URLSearchParams(window.location.search);
        url.delete(param);
        props.history.push(window.location.pathname + "?" + url.toString());
        let tmp = filterData
        tmp[param].map(el => el.checked = false)
        setFilterData({ ...tmp })
        getCargoLog();
    }

    const dropdownHandler = (tag, val) => {
        let tmp = filterData
        tmp[tag].map(el => {
            if (el.name == val.name) {
                if (!val.checked) {
                    el.checked = true
                } else {
                    el.checked = false
                }
            }
        })
        let tmpArr = (tmp[tag].filter(el => el.checked)).map(el => el.value)
        setToUrl(tmpArr, tag)
        setFilterData({ ...tmp })
    }

    const [filterData, setFilterData] = useState({
        natureType: [
            {
                name: "کوچک",
                value: "small",
                checked: getFromUrl("natureType") === "small" ? true : false
            },
            {
                name: "بزرگ",
                value: "big",
                checked: getFromUrl("natureType") === "big" ? true : false
            },
        ]
    })

    const checkUrl = () => {
        let result = false;
        const defaultParams = {
            natureType: [],
            search: "",
            from: '',
            to: ''
        }
        const check = ["natureType", "search", "from", "to"]
        check.map(filter => {
            if (Array.isArray(getFromUrl(filter))) {
                if (getFromUrl(filter).length > 0) {
                    result = true;
                }
            } else {
                if (getFromUrl(filter) != defaultParams[filter]) {
                    result = true;
                }
            }
        })
        return result
    }

    const deleteAllFiletrs = () => {
        const check = ["natureType", "search", "from", "to"]
        let url = new URLSearchParams(window.location.search);
        let filterDataTemp = filterData;
        check.map(filter => {
            url.delete(filter);
            props.history.push(window.location.pathname + "?" + url.toString());
            if (filter == "natureType") {
                filterDataTemp.natureType = filterDataTemp.natureType.map(obj => {
                    return { ...obj, checked: false };
                })
            }
        })
        setFilterData({ ...filterDataTemp })
        getCargoLog();
    }

    const addChannel = async (email, password) => {
        let params = { username: toEnglishNumber(email), password: toEnglishNumber(password) };
        let res = await SubmitAddChannel(params)
        setEditChannel({ ...editChannel, show: false })

        return res;
    }


    const insideCargoListRenderer = () => {
        if (cargoModal.channelList.length < 1) {
            return <div className={style.emptyWrapper}>
                <img src={CargoEmptyState} className={style.emptyImage} />
                <p className={style.normalText}>اینجا می‌تونید تنطیمات ساخت خودکار محموله برای فرستادن به انبار رو ایجاد کنید</p>
                <p className={style.boldText}>برای شروع پنل دیجی‌کالا رو ثبت کنید</p>
                <div className={style.buttonWrapper}>
                    <div className={style.pannelsPageBtn}>
                        <Button
                            disabled={false}
                            tag="newPannelPage"
                            type="noBorder"
                            label="ورود به صفحه‌ی پنل دیجی‌کالا"
                            onclick={() => props.history.push('/channels')}
                        />
                    </div>
                    <div className={style.newPannelBtn}>
                        <Button
                            disabled={false}
                            tag="newPannel"
                            type="solid"
                            label="ثبت پنل جدید"
                            onclick={
                                // () => setEditChannel({ ...editChannel, show: true })
                                () => props.history.push('/channels')
                            }
                        />
                    </div>
                </div>
            </div>
        }
        if (logList.list.length < 1) {
            return <div className={style.emptyWrapper}>
                <img src={CargoEmptyState} className={style.emptyImage} />
                <p className={style.normalText}>اینجا می‌تونید تنطیمات ساخت خودکار محموله برای فرستادن به انبار رو ایجاد کنید</p>
                <p className={style.boldText}>در حال حاضر تنظیماتی برای ساخت خودکار محموله ندارید</p>
                <div className={style.buttonWrapper}>
                    <div className={style.newConfigBtn}>
                        <Button
                            disabled={false}
                            tag="newConfig"
                            type="solid"
                            label="تنظیمات ساخت محموله"
                            onclick={() => setCargoModal({ ...cargoModal, show: true })}
                        />
                    </div>
                </div>
            </div>
        }
        if (cargoModal.channelList.length > 0 && logList.list && logList.list.length > 0) {
            return <div className={style.logWrapper}>
                <div className={style.pagination}>
                    <div className={style.Dropdown}>
                        <Pagination
                            tag="page"
                            currentPage={parseInt(getFromUrl("page"))}
                            pageCount={logList.logListPageCount}
                            setPage={setToUrl}
                        />

                        <TinyDropdown
                            placeholder={10}
                            dropdownList={["10", "25", "50", "75", "100"]}
                            selected={selected => {
                                setToUrl(selected, 'pageNumber')
                            }}
                            selectedItem={getFromUrl('pageNumber')}
                        />
                        <div className={style.label}>تعداد نمایش در صفحه</div>
                        <div className={style.verticalLine}></div>
                        <div
                            className={style.variantCount}>{toPersianNumber(logList.resultNumber)} نتیجه</div>
                    </div>
                </div>

                {/* Render Log List */}
                <div>
                    <div className={style.hiddenListShadow}></div>
                    <div className={style.logListWrapper}>
                        <div className={offset > 400 ? style.listHeaderFixed : style.listHeader}>
                            <div className={style.listHeaderItem40}></div>
                            <div className={style.listHeaderItem176}>شماره محموله</div>
                            <div className={style.listHeaderItem120}>ساخت محموله</div>
                            <div className={style.listHeaderItem120}>پنل فروش</div>
                            <div className={style.listHeaderItem132}>انبار</div>
                            <div className={style.listHeaderItem48}>نوع</div>
                        </div>
                        <div className={offset > 400 ? style.hiddenListHeader : ''}></div>
                        {logList.list.map((item, index) => <LogCard
                            key={index}
                            data={item}
                            warehouses={logList.warehouses}
                            channelList={cargoModal.channelList.filter(el => el._id == item.channel)}
                        />)}
                    </div>
                </div>

                <div className={style.paginationTwo}>
                    <Pagination
                        tag="page"
                        currentPage={parseInt(getFromUrl("page"))}
                        pageCount={logList.logListPageCount}
                        setPage={setToUrl}
                    />
                </div>
            </div>
        }
    }

    if (hasSkeleton) {
        return <Skeleton />
    } else {
        return (
            <div className={style.wrapper}>
                <Toast
                    tag='Toast'
                    text={toast}
                    value={toast ? true : false}
                    parentClose={closeToastFunction}
                />
                <EditChannelModal
                    show={editChannel.show}
                    closemodal={() => setEditChannel({ ...editChannel, show: false })}
                    email=''
                    editchannel={addChannel}
                />
                {
                    props.user.expiredAccount &&
                    <div className={style.gradientWrapper}>
                        <GradientToast tag="test" value={true}>
                            <>
                                <p className={style.expiredTitle}>شارژ کیف پول شما تمام شده‌است.</p>
                                <p className={style.expiredText}>برای فعال‌سازی مجدد ربات، کیف پول خود را شارژ کنید.</p>
                                <Link className={style.expiredLink} to={'/chargewallet'}>ورود به صفحه‌ی  شارژ کیف پول  </Link>
                            </>
                        </GradientToast>
                    </div>
                }
                {
                    props.user.disconnected.status &&
                    <div className={style.gradientWrapper}>
                        <GradientToast tag="test" value={true}>
                            <>
                                <p className={style.expiredTitle}>{disconnectTextGenerator(props.user.disconnected.channelName)}</p>
                                <p className={style.expiredText}>جهت اتصال دوباره موبیشا به پنل، لطفا اطلاعات خود را در صفحه پنل دیجی‌کالا به‌روز رسانی کنید</p>
                                <Link className={style.expiredLink} to={'/channels'}>ورود به صفحه‌ی  پنل دیجی‌کالا  </Link>
                            </>
                        </GradientToast>
                    </div>
                }

                {/* <div className={style.gradientWrapper}>
                    <GradientToast tag="test" value={true}>
                        <GeneralWarning />
                    </GradientToast>
                </div> */}

                <CargoModal
                    show={cargoModal.show}
                    cargoConfigs={logList.cargoConfigs}
                    closeModal={() => setCargoModal({ ...cargoModal, show: false })}
                    channels={cargoModal.channelList}
                    updateCargoConfigs={updateCargoConfigs}
                />

                <DeleteCargoModal
                    show={cargoModal.deleteShow}
                    closeModal={() => setCargoModal({ ...cargoModal, deleteShow: false })}
                    cargoConfigs={logList.cargoConfigs}
                    deleteCargoConfigFunction={deleteCargoConfigFunction}
                />

                <div className={style.header}>
                    <h1>محموله‌ها</h1>
                    {cargoModal.channelList.length > 0 && <div className={style.buttonsWrapper}>
                        {logList.cargoConfigs.length > 0 && <div className={style.settingButton}>
                            <button
                                className={style.deleteCargoConfig}
                                onClick={() => setCargoModal({ ...cargoModal, deleteShow: true })}
                            >
                                حذف ساخت اتومات محموله
                            </button>
                        </div>}
                        <div className={style.settingButton}>
                            <Button
                                disabled={false}
                                tag="n2"
                                type="solid"
                                label="تنظیمات ساخت محموله"
                                onclick={() => setCargoModal({ ...cargoModal, show: true })}
                            />
                        </div>
                    </div>}
                </div>

                {cargoModal.channelList.length > 0 && logList.cargoConfigs && <div className={style.chargeStatus}>
                    <div className={style.searchWrapper}>
                        <Searchbar
                            placeholder={"شماره محموله و یا انبار"}
                            value={getFromUrl("search") ? getFromUrl("search") : ''}
                            tag="search"
                            searchValue={setToUrl}
                        />
                    </div>
                    <div className={style.filterWrapper}>
                        {checkUrl() ? <div className={style.deleteAll} onClick={() => deleteAllFiletrs()}>
                            <span className={style.icon}>g</span>
                        </div> : null}
                        <div className={style.calendarWrapper}>
                            <CalendarModal
                                label={dateRangeLabel}
                                dateLabel={(label) => {
                                    setDateRangeLabel(label)
                                }}
                                setRange={(range) => {
                                    setDateRange(range)
                                }}
                                // فعلا بازه زمانی نداریم 
                                value={getFromUrl("from") ? { start: getFromUrl("from"), end: getFromUrl("to") } : null}
                                openModal={openCalendarModal}
                            />
                        </div>
                        <div className={style.typeWrapper}>
                            <Dropdown
                                tag='natureType'
                                label='نوع محموله'
                                placeHolder='نوع محموله'
                                dropdownList={filterData.natureType}
                                deleteSelectedItems={deleteFromUrl}
                                handleSelect={dropdownHandler}
                                action={getCargoLog}
                                hasCheckbox={true}
                            />
                        </div>
                    </div>
                </div>}

                {insideCargoListRenderer()}

            </div>
        )
    }
}

export default withRouter(Cargo);

